<template>
  <div v-clickout class="cp-input-search" @clickout="showContent = false">
    <input
      v-model="searchKey"
      type="text"
      :placeholder="placeholder"
      @focus="showContent = true"
      @keyup="showContent = true"
      @keyup.enter="search"
    />
    <i class="icon-search"></i>
    <div
      v-show="showContent && searchList.length"
      class="cp-input-search__content"
    >
      <div
        v-for="(item, i) in searchList"
        :key="i"
        class="cp-input-search__content-item ellipsis-1"
        @click="
          $util.clickStat(`LBZX/SS${i + 1}`, `礼包中心/搜索${i + 1}`)
          goSearch(item)
        "
      >
        {{ getVal(item) }}
      </div>
    </div>
  </div>
</template>

<script>
import { clickout } from '~/plugins/vue-clickout'
export default {
  directives: {
    clickout
  },
  props: {
    placeholder: {
      type: String,
      default: '请输入...'
    },
    list: {
      type: Array,
      default: () => []
    },
    defaultKey: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: Number.MAX_VALUE
    }
  },
  data() {
    return {
      showContent: false,
      searchKey: null
    }
  },
  computed: {
    searchList() {
      return this.searchKey
        ? this.list
            .filter((e) => (e[this.defaultKey] || '').includes(this.searchKey))
            .slice(0, this.limit)
        : []
    }
  },
  watch: {
    searchKey(val) {
      this.$emit('change', val)
    }
  },
  methods: {
    search() {
      const item = this.searchList[0]
      if (item) {
        this.goSearch(item)
      }
    },
    goSearch(item) {
      this.searchKey = this.getVal(item)
      this.showContent = false
      this.$emit('search', item)
    },
    getVal(item) {
      return this.defaultKey ? item[this.defaultKey] : item
    }
  }
}
</script>

<style lang="scss">
@import '~assets/scss/mixin.scss';
.cp {
  &-input {
    &-search {
      position: relative;
      display: inline-block;
      width: 200px;
      height: 30px;
      color: #afbdd9;
      font-size: 14px;
      vertical-align: middle;
      &__content {
        @include scrollbar;
        max-height: 150px;
        margin-top: 10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(183, 188, 206, 0.75);
        border-radius: 4px;
        border: solid 1px #c4d2f2;
        text-align: center;
        overflow: auto;
        &-item {
          box-sizing: border-box;
          height: 30px;
          line-height: 30px;
          border-bottom: 1px solid #eef4ff;
          &:last-child {
            border: none;
          }
          &:hover {
            cursor: pointer;
            background-color: #eef4ff;
          }
        }
      }
      input {
        width: 100%;
        height: 100%;
        text-indent: 1em;
        color: #afbdd9;
        border-radius: 15px;
        border: solid 1px #508aff;
      }
      i {
        position: absolute;
        top: 6px;
        right: 9px;
      }
    }
  }
}
</style>
